import Vue from 'vue'
import App from './App.vue'
import router from "@/router"
import store from "@/store"
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import Notifications from 'vue-notification'
import {abilitiesPlugin} from "@casl/vue";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "./assets/styles/index.css"
import abilities from "@/app/services/abilities";
import moment from "moment/moment";
import axios from "axios";
import {bumpSessionRevision} from "@/app/services/tokenRefresh";
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Notifications)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false
Vue.use(abilitiesPlugin, abilities, {
  useGlobalProperties: true,
});

if (!window.location.pathname.match(/login/)) {
  window.loginReferrer = {
    pathname: location.pathname,
    href: location.href,
  };
}
// stop auth loader
Vue.prototype.$authLoading = false;

axios.interceptors.response.use(
    function(response) {
      return response;
    },
    function(error) {
      if (error.response.status === 403) {
        bumpSessionRevision();
        sessionStorage.clear();
        window.location.reload();
      } else if (error.response.status === 401) {
        bumpSessionRevision();
        sessionStorage.clear();

        const logoutChannel = new BroadcastChannel('auth-channel');
        logoutChannel.postMessage('LOGOUT');
        logoutChannel.close();

        window.location.reload();
      }
      return Promise.reject(error);
    }
);

(async () => {
  await (function () {
    const authChannel = new BroadcastChannel('auth-channel');

    authChannel.onmessage = function (event) {
      if (event.data === 'LOGOUT') {
        sessionStorage.clear();
        localStorage.clear();
        window.location.reload();
      } else if (event.data && event.data.type === 'LOGIN') {
        if (!sessionStorage.getItem('access_token') && !sessionStorage.getItem('current_user')) {
          const data = event.data.payload;
          if (data.accessToken) sessionStorage.setItem('access_token', JSON.stringify(data.accessToken));
          if (data.user) sessionStorage.setItem('current_user', JSON.stringify(data.user));
          if (data.refreshToken) sessionStorage.setItem('tokenRefresh', data.refreshToken);
          if (data.abilities) sessionStorage.setItem('abilities', JSON.stringify(data.abilities));
          if (data.refreshTokenExpiryTime) sessionStorage.setItem('refreshTokenExpiryTime', data.refreshTokenExpiryTime);

          let usr = JSON.parse(sessionStorage.getItem("current_user"));
          Vue.prototype.$userProfile = usr;
          Vue.prototype.$authLoading = false;

          const urlParams = new URLSearchParams(window.location.search);
          const nextUrl = urlParams.get('nextUrl');
          if (nextUrl) {
            window.location.assign(nextUrl);
          } else if (window.location.pathname.startsWith('/auth/login') || window.location.pathname === '/' || window.location.pathname === '/auth') {
            window.location.assign('/home/dashboard');
          } else {
            window.location.reload();
          }
        }
      } else if (event.data && event.data.type === 'REQUEST_SESSION') {
        const token = sessionStorage.getItem('access_token');
        if (token) {
          authChannel.postMessage({
            type: 'SHARE_SESSION',
            payload: {
              accessToken: JSON.parse(token),
              user: JSON.parse(sessionStorage.getItem('current_user') || '{}'),
              refreshToken: sessionStorage.getItem('tokenRefresh'),
              abilities: JSON.parse(sessionStorage.getItem('abilities') || '[]'),
              refreshTokenExpiryTime: sessionStorage.getItem('refreshTokenExpiryTime')
            }
          });
        }
      } else if (event.data && event.data.type === 'SHARE_SESSION') {
        if (!sessionStorage.getItem('access_token') && !sessionStorage.getItem('current_user')) {
          const data = event.data.payload;
          if (data.accessToken) sessionStorage.setItem('access_token', JSON.stringify(data.accessToken));
          if (data.user) sessionStorage.setItem('current_user', JSON.stringify(data.user));
          if (data.refreshToken) sessionStorage.setItem('tokenRefresh', data.refreshToken);
          if (data.abilities) sessionStorage.setItem('abilities', JSON.stringify(data.abilities));
          if (data.refreshTokenExpiryTime) sessionStorage.setItem('refreshTokenExpiryTime', data.refreshTokenExpiryTime);

          let usr = JSON.parse(sessionStorage.getItem("current_user"));
          Vue.prototype.$userProfile = usr;
          Vue.prototype.$authLoading = false;

          const urlParams = new URLSearchParams(window.location.search);
          const nextUrl = urlParams.get('nextUrl');
          if (nextUrl) {
            window.location.assign(nextUrl);
          } else if (window.location.pathname.startsWith('/auth/login') || window.location.pathname === '/' || window.location.pathname === '/auth') {
            window.location.assign('/home/dashboard');
          } else {
            window.location.reload();
          }
        }
      }
    };

    if (!sessionStorage.getItem('access_token') && !sessionStorage.getItem('current_user')) {
      if (window.loginReferrer && window.loginReferrer.pathname !== "/") {
        Vue.prototype.$authLoading = true;
      }
      authChannel.postMessage({ type: 'REQUEST_SESSION' });
    }
  })();
})();


Vue.mixin({
  methods: {
    dataURLtoFile(base64String, filename) {
      let bstr = atob(base64String),
          n = bstr.length,
          u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: "application/pdf" });
    },
    appendQueryParams(data) {
      return `?${Object.keys(data).map(k=>`${k}=${data[k]}`).join('&')}`
    },
    successToast: function (
        title = "Success",
        text = "Request was processed successfully"
    ) {
      this.$notify({
        group: "foo",
        type: "success",
        title: title,
        text: text,
      });
    },
    errorToast: function (
        title = "Error",
        text = "Something went wrong try again later"
    ) {
      this.$notify({
        group: "foo",
        type: "error",
        title: title,
        text: text,
      });
    },
    warningToast: function (
        title = "Warning",
        text = "It seems something is not right"
    ) {
      this.$notify({
        group: "foo",
        type: "warn",
        title: title,
        text: text,
      });
    },
    filterUnitData(data) {
      let arrayData = [];
      let obj = {};
      data.forEach(list => {
        obj = {
          value: list.id,
          text: list.name
        };
        arrayData.push(obj);
      });

      return arrayData;
    },
    cleanUnderscores(name){
      let n = name.replaceAll("_", " ")
      return n.charAt(0).toUpperCase() + n.slice(1)
    },
    onlyNumberValidator(event) {
      if (!/[+-/*()\d]/.test(event.key)) return event.preventDefault();
    },
    dateFormat(date){
      if(date){
        return moment(date).format("DD/MM/YYYY")
      }
      return ""
    },
    dateTimeFormat(date){
      if(date){
      return moment(date).format("DD-MM-YYYY h:mmA")
      }
      return ""
    },
    dateRangeFormat(date){
      if(date){
        return moment(date).format("YYYY-MM-DD HH:mm:ss")
      }
      return null
    },
    cleanEntityType(name){
      if(name == null){
        return ""
      }
      let n = name.replaceAll("-", " ")
      return n.charAt(0).toUpperCase() + n.slice(1)
    },
    determineLockDown(compliance){
      if(compliance.filingProcess === "DORMANCY" || compliance.filingProcess === "CHANGE_OF_NAME" || compliance.filingProcess === "AMALGAMATION" || compliance.filingProcess === "CONVERSION"){
        return true
      }
      return false
    },
    objectToQueryParams(objectToParse) {
      return Object.keys(objectToParse).map(key => key + '=' + objectToParse[key]).join('&');
    },
    pdfValidator(data) {
      if (data) {
        let fileSections = data.name.split(".");
        let pdfBool = false;
        if ((fileSections[fileSections.length - 1].includes("pdf") || fileSections[fileSections.length - 1].includes("PDF"))  && data.type === "application/pdf") {
          pdfBool = true;
        }
        return pdfBool;
      }
      return false;
    },
    showConfirmDialog(message = "Are you sure of this action ?") {
      this.boxTwo = ''
      return this.$bvModal.msgBoxConfirm(message, {
        title: 'Please Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: true,
        centered: true
      })

    },
    calculateAssignmentDuration(updatedAt) {
      if (!updatedAt) return '';
      
      const now = moment();
      const assignmentTime = moment(updatedAt);
      const duration = moment.duration(now.diff(assignmentTime));
      
      const months = Math.floor(duration.asMonths());
      const days = Math.floor(duration.asDays());
      const hours = Math.floor(duration.asHours());
      const minutes = Math.floor(duration.asMinutes());
      
      if (months > 0) {
        return `${months} month${months > 1 ? 's' : ''} ago`;
      } else if (days > 0) {
        return `${days} day${days > 1 ? 's' : ''} ago`;
      } else if (hours > 0) {
        return `${hours} hour${hours > 1 ? 's' : ''} ago`;
      } else if (minutes > 0) {
        return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
      } else {
        return 'Just assigned';
      }
    },
    filingName(name) {
      if (name === "APPEND_INFORMATION") {
        return "#resolution"
      }

      if (name === "FORM_13") {
        name = "FORM_16"
      } else if (name === "FORM_14") {
        name = "FORM_17"
      } else if (name === "FORM_15") {
        name = "FORM_18"
      } else if (name === "FORM_17") {
        name = "FORM_20"
      } else if (name === "FORM_16") {
        name = "FORM_19"
      }
      if (name === "FORM_19") {
        name = "FORM_22"
      }
      if (name === "FORM_20") {
        name = "FORM_23"
      }
      if (name === "FORM_21") {
        name = "FORM_24"
      }
      if (name === "FORM_22") {
        name = "FORM_25"
      }
      if (name === "FORM_23") {
        name = "FORM_26"
      }

      if (name === "FILE_FORM_10") {
        name = "FILE_FORM_13"
      }
      if (name === "FILE_FORM_17") {
        name = "FILE_FORM_20"
      }
      if (name === "FILE_FORM_20") {
        name = "FILE_FORM_23"
      }
      if (name === "FILE_FORM_19") {
        name = "FILE_FORM_22"
      }
      if (name === "FILE_FORM_18") {
        name = "FILE_FORM_21"
      }


      return "#" + name.replaceAll("_", "").toLowerCase();
    }

  },
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
